import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'
import { isMsSiteSelection, isK5SiteSelection } from 'utils/productHelpers'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: [
    'feature_LEARN-20108-ms-site-selection',
    'feature_LEARN-20164-k5-site-selection',
  ],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: (_, subscribedFlags) =>
    isMsSiteSelection(_, subscribedFlags) ||
    isK5SiteSelection(_, subscribedFlags),
})

export default FlagToggler
